'use strict'
import axios from 'axios'
import { fetchEventSource } from '@microsoft/fetch-event-source'
// import store from '@/store'
// import router from '@/router'
import bus from './bus.js'
// import { getToken, getTenant } from '@/utils/auth'
// import { sysAppId, isLocal } from '@/settings.js'

// import qs from 'qs'
// const {API_ROOT} = require('../../static/config.js')
// const config = require('../../static/config.js')
// const API_ROOT = (window.top.window.g && window.top.window.g.CHAT_API_ROOT) ? window.top.window.g.CHAT_API_ROOT : window.httpConfig.API_ROOT
const API_ROOT = window.httpConfig.API_ROOT
let API_APPLET_ROOT = window.httpConfig.API_APPLET_ROOT_PC

if (window.innerWidth <= 663) { // 移动端要调用兰工移动端的接口
  API_APPLET_ROOT = window.httpConfig.API_APPLET_ROOT
}

// 处理请求数据 9101
const whiteList = [ // 一体化接口需要token的
  '/api/Jwt/GetUserByToken'
]
const otherList = [// 语音转文字后台
  '/consultation-web/api/speechRecognition'
]

axios.interceptors.request.use(
  config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // =========================================================
    // 请求拦截
    // const isToken = (config.headers || {}).isToken === false
    if (whiteList.indexOf(config.url) > -1) {
      let token = localStorage.getItem('YT_accessToken')
      config.headers['Authorization'] = 'Bearer ' + token
      config.headers['sysappid'] = '23021984-5501-4870-8ba6-1a48a2ef0d17'
    } else {
      let token = localStorage.getItem('token')
      config.headers['Authorization'] = 'Bearer ' + token
    }
    /* if (config.headers['Content-Type'] !== 'application/x-www-form-urlencoded') {
      if (config.method === 'post' || config.method === 'POST') {
        config.data = qs.stringify(config.data)
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } */
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    // 响应拦截
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

function getData (val, url) {
  // 处理请求数据
  /* const whiteList = [
      "/login",

    ] */
  // 判断登录用户信息/权限
  if (whiteList.join(',').indexOf(url) >= 0) {
    // 密码登录：登录    手机登录：获取验证码、登录
    return val
  }
  if (typeof val === 'string') {
    return JSON.parse(val)
  } else {
    return val
  }
}
// 请求参数
function getOptions (url, method, data, params, queryAndBody) {
  let flag = false
  if (whiteList.includes(url)) {
    flag = true
  }
  let otherFlag = false
  if (otherList.includes(url)) {
    otherFlag = true
  }
  // eslint-disable-next-line no-unused-vars
  const _url = flag ? window.httpConfig.API_LOGIN_ROOT : otherFlag ? window.httpConfig.API_OTHER_ROOT : API_ROOT
  const options = {
    method: method,
    baseURL: _url, // _url
    url: url,
    timeout: 10000,
    headers: {}
  }
  if (queryAndBody) {
    const paramsData = data
    const bodyObject = paramsData.bodyObject
    delete paramsData.bodyObject
    options.headers['Content-Type'] = 'application/json;charset=UTF-8'
    options.params = getData(paramsData, url)
    options.data = getData(bodyObject, url)
  } else {
    const pd = !params ? 'data' : 'params'
    options[pd] = getData(data, url)
  }

  return options
}

// eslint-disable-next-line no-unused-vars
function checkStatus (response) {
  // 处理响应数据
  if (response && (response.status === 200 || response.status === 204)) {
    // loading,如果http状态码正常，则直接返回数据
    let res = response.data
    if (!res) {
      bus.$message.error('服务器开了个小差')
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    }
    if (res.statusCode === 200 || res.statusCode === 204 || res.code === 200) {
      return res.data
    } else if (res.code === 10000) {
      return res.content
    } else {
      if (res.errors && res.errors !== '群组Id错误') {
        bus.$message.error(res.errors)
      }
      if (res.message) {
        bus.$message.error(res.message)
      }
      return Promise.reject(res)
    }
  } else {
    if (response.data.error && !response.data.error.code) {
      bus.$message.error(response.data.error.message)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    } else {
      return Promise.reject(response.data)
    }
  }
}

function checkCode (_error) {
  bus.$message.error('网络异常~')
}

export default {
  post (url, data, query, queryAndBody) {
    const options = getOptions(url, 'post', data, query, queryAndBody)
    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(checkStatus(response))
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  /* postOther (url, data) {
    // const formData = new FormData()
    // Object.keys(data).forEach((key) => {
    //   formData.append(key, data[key])
    // })
    const options = {
      method: 'post',
      baseURL: window.httpConfig.API_OTHER_ROOT,
      url: url,
      timeout: 10000,
      headers: {
        Accept: 'text/event-stream',
        'Content-Type': 'application/json'
      },
      transformRequest: [function (data, headers) {
        // 去除post请求默认的Content-Type
        delete headers.post['Content-Type']
        return data
      }]
    //   data: formData
    }
    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
        //   resolve(checkStatus(response))
          resolve(response)
        })
        .catch(res => {
          reject(res)
        })
    })
  }, */
  fetchEvent (data) {
    return new Promise((resolve, reject) => {
      fetchEventSource('http://localhost:8082', {
        method: 'POST',
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        onmessage (ev) {
          console.log('Received message:', ev.data)
          // 这里可以根据接收到的流式数据更新前端界面
          resolve(ev.data)
        },
        onclose () {
          console.log('Connection closed by server')
          resolve('onclose')
        },
        onerror (err) {
          console.error('Error received:', err)
          reject(err)
        }
      })
    })
  },
  postForm (url, data) {
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    const options = {
      method: 'post',
      baseURL: API_ROOT,
      url: url,
      timeout: window.httpConfig.AXIOS_TIMEOUT ? window.httpConfig.AXIOS_TIMEOUT : 10000,
      transformRequest: [function (data, headers) {
        // 去除post请求默认的Content-Type
        delete headers.post['Content-Type']
        return data
      }],
      data: formData
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  postApplet (url, data, query) {
    const options = {
      method: 'post',
      baseURL: API_APPLET_ROOT,
      url: url,
      timeout: 10000,
      data: data
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  get (url, data, query) {
    const options = getOptions(url, 'get', data, query)
    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(checkStatus(response))
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  getApplet (url, data, query) {
    const options = {
      method: 'get',
      baseURL: API_APPLET_ROOT,
      url: url,
      timeout: 10000,
      transformRequest: [function (data, headers) {
        // 去除post请求默认的Content-Type
        delete headers.post['Content-Type']
        return data
      }],
      params: data
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  put (url, data, query, queryAndBody) {
    const options = getOptions(url, 'put', data, query, queryAndBody)
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  putApplet (url, data, query, queryAndBody) {
    const options = {
      method: 'put',
      baseURL: API_APPLET_ROOT,
      url: url,
      timeout: 10000,
      data: data
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  delete (url, data) {
    const options = getOptions(url, 'delete', data, 'query')
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  deleteApplet (url, data) {
    const options = {
      method: 'delete',
      baseURL: API_APPLET_ROOT,
      url: url,
      timeout: 10000,
      data: data
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
}



// WEBPACK FOOTER //
// ./packages/api/http.js